import React from "react";
import "@/App.css";
import { Toaster } from "sonner";
import { LanguageProvider } from "./i18n/LanguageContext";
import Header from "./components/sections/Header";
import Hero from "./components/sections/Hero";
import Marquee from "./components/sections/Marquee";
import Services from "./components/sections/Services";
import Differentiators from "./components/sections/Differentiators";
import Projects from "./components/sections/Projects";
import Testimonials from "./components/sections/Testimonials";
import Contact from "./components/sections/Contact";
import Footer from "./components/sections/Footer";

function App() {
  return (
    <LanguageProvider>
      <div className="App" data-testid="app-root">
        <Header />
        <main>
          <Hero />
          <Marquee />
          <Services />
          <Projects />
          <Differentiators />
          <Testimonials />
          <Contact />
        </main>
        <Footer />
        <Toaster
          position="bottom-center"
          toastOptions={{
            style: {
              borderRadius: 0,
              background: "#111",
              color: "#fff",
              border: "1px solid #262626",
              fontFamily: "Inter, sans-serif",
            },
          }}
        />
      </div>
    </LanguageProvider>
  );
}

export default App;
